// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/DeviceScreenShotsPage/styles.scss
// module id = 1106
// module chunks = 0